import { render, staticRenderFns } from "./cooperativeAlliance.vue?vue&type=template&id=64e1b6b7&scoped=true&"
import script from "./cooperativeAlliance.vue?vue&type=script&lang=js&"
export * from "./cooperativeAlliance.vue?vue&type=script&lang=js&"
import style0 from "./cooperativeAlliance.vue?vue&type=style&index=0&id=64e1b6b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e1b6b7",
  null
  
)

export default component.exports